import {connect} from 'react-redux'
import PrivateRoute from './PrivateRoute'
import {bindActionCreators, compose} from 'redux'
import loader from '../../Commun/Loader/loader'
import {fetchUser, USER} from '../../../redux/actions/app/user/user.actions'
import {getLogin, getErrorEntity, getLoading, getLoadingEntity} from '../../../redux/selectors/ui/ui.selectors'
import {APP_URL_PASS} from "../../../config/constants";

const mapStateToProps = state => {
    return {
        login: getLogin(state),
        fail: getErrorEntity(state, USER),
        query: `${APP_URL_PASS}/user`,
        loaded: getLoading(state) !== undefined && !getLoadingEntity(state, USER)
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    // ?provider=pros vérifie que l'utilisateur est bien un Pro (pas un Customer)
    fetchUser: ({query}) => fetchUser({query: `${query}?refresh=true&provider=pros`})
}, dispatch)

const PrivateRouteContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    loader()
)(PrivateRoute)

export default PrivateRouteContainer
